export const environment = {
  production: true,
  buildId: '3237638671221011',
  configFile: 'config.json',
};
